// extracted by mini-css-extract-plugin
export default {"tooltip":"G_yGv6","content":"_REMUN"};